"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = CloseIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
function CloseIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26444 4.37008C5.06918 4.17482 4.7526 4.17482 4.55734 4.37008C4.36207 4.56534 4.36207 4.88192 4.55734 5.07719L11.7827 12.3026L4.55734 19.528C4.36207 19.7232 4.36207 20.0398 4.55734 20.2351C4.7526 20.4303 5.06918 20.4303 5.26444 20.2351L12.4898 13.0097L19.7152 20.2351C19.9105 20.4303 20.2271 20.4303 20.4223 20.2351C20.6176 20.0398 20.6176 19.7232 20.4223 19.528L13.1969 12.3026L20.4223 5.07719C20.6176 4.88192 20.6176 4.56534 20.4223 4.37008C20.2271 4.17482 19.9105 4.17482 19.7152 4.37008L12.4898 11.5955L5.26444 4.37008Z"
  }));
}